var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 10L5.41634 7.58333C5.55223 7.31345 5.75894 7.08559 6.01435 6.92412C6.26976 6.76266 6.56426 6.67366 6.86634 6.66667H15.833M15.833 6.66667C16.0876 6.66622 16.3389 6.72411 16.5677 6.8359C16.7965 6.94769 16.9966 7.1104 17.1527 7.31155C17.3087 7.5127 17.4167 7.74694 17.4682 7.99629C17.5197 8.24564 17.5133 8.50347 17.4497 8.75L16.1663 13.75C16.0735 14.1096 15.8632 14.4279 15.5688 14.6544C15.2744 14.8809 14.9128 15.0025 14.5413 15H2.49967C2.05765 15 1.63372 14.8244 1.32116 14.5118C1.0086 14.1993 0.833008 13.7754 0.833008 13.3333V2.5C0.833008 2.05797 1.0086 1.63405 1.32116 1.32149C1.63372 1.00893 2.05765 0.833332 2.49967 0.833332H5.74967C6.02841 0.830599 6.30339 0.897822 6.54942 1.02885C6.79546 1.15988 7.00471 1.35052 7.15801 1.58333L7.83301 2.58333C7.98476 2.81377 8.19136 3.00293 8.43426 3.13383C8.67715 3.26474 8.94875 3.33329 9.22467 3.33333H14.1663C14.6084 3.33333 15.0323 3.50893 15.3449 3.82149C15.6574 4.13405 15.833 4.55797 15.833 5V6.66667Z",
    stroke: "#1A2E1A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.3237752d270c00f8cb1937dc1e7d35b6.svg";
export { ForwardRef as ReactComponent };